import type { QuerySettings } from '@customTypes/index';
import { useQuery } from '@tanstack/react-query';

import type { GetClubProfilePenaltiesRequest } from '@/shared/api/requests/club/penalties/get/request';
import { getClubProfilePenalties } from '@/shared/api/requests/club/penalties/get/request';

export const useClubProfilePenaltiesQuery = (
  params: GetClubProfilePenaltiesRequest,
  settings?: QuerySettings<typeof getClubProfilePenalties>
) =>
  useQuery({
    queryKey: ['ClubProfilePenalties', params.clubId],
    queryFn: () =>
      getClubProfilePenalties({
        params,
        config: settings?.config
      }),
    ...settings?.options
  });
